<div class="page-caption" *ngIf="userTypeRole === 'Beneficiary'">
    <h5 class="common-bene-class-for-translation"> Your profile view to others </h5>
</div>
<div class="main-content setting-profileview-control" *ngIf="userTypeRole === 'Beneficiary'">
    <div class="card user-name-card card-body">
        <div class="flex-row bold-bottom-border pb-20">
            <div>
                <div>
                    <h6 class="common-bene-class-for-translation"> Visibility of your profile in searches </h6>
                </div>
                <div class="un-sub-ttle common-bene-class-for-translation">
                    Choose what information of your profile should appear to other members and petitioners.
                </div>
            </div>

            <div class="align-right">
                <a class="primary" data-toggle="collapse" #searchControlBlock href="#collapseBox1" role="button"
                    aria-expanded="false">
                    <span class="common-bene-class-for-translation"
                        [ngClass]="{'noDipsplay': !searchcontrol_block_change}">Change</span>
                    <span class="common-bene-class-for-translation"
                        [ngClass]="{'noDipsplay':  searchcontrol_block_change}">Close</span>
                </a>
            </div>
        </div>

        <div class="collapse" id="collapseBox1">

            <div class="row border-top"></div>

            <mat-radio-group class="ml-3" [(ngModel)]="searchAllow">
                <mat-label> <span class="common-bene-class-for-translation">Do you want to appear in the search list
                        when other members or petitioners look for you?</span>
                </mat-label>
                <mat-radio-button class="radio-button" name="searchAllow" [value]="true">
                    <span class="common-bene-class-for-translation">Yes</span>
                </mat-radio-button>
                <mat-radio-button class="radio-button" name="searchAllow" [value]="false">
                    <span class="common-bene-class-for-translation">No</span>
                </mat-radio-button>
            </mat-radio-group>
            <ng-container *ngIf="searchAllow">
                <div class="row">
                    <div class="col-md-12">
                        <div class="common-bene-class-for-translation">How much data from your profile you want them to
                            view?</div>
                        <mat-radio-group [(ngModel)]="searchLimited">
                            <mat-radio-button class="radio-button" [ngClass]="{'highlightTextg1':searchLimited}"
                                name="searchLimited" [value]="true">
                                <span class="common-bene-class-for-translation">Limited information</span>
                            </mat-radio-button>

                            <mat-radio-button class="radio-button" [ngClass]="{'highlightTextg1':!searchLimited}"
                                name="searchLimited" [value]="false">
                                <span class="common-bene-class-for-translation">Full information</span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <!---desc--->
                <div class="row pb-2" [ngClass]="{'highlightTextg1':searchLimited}" *ngIf="searchLimited">
                    <div class="col-md-12">
                        <p><small class="common-bene-class-for-translation">Following information from your profile will
                                be displayed</small></p>
                        <ul class="desc">
                            <li><small><strong class="common-bene-class-for-translation">1.Full Name</strong></small>
                            </li>
                            <li><small><strong class="common-bene-class-for-translation">2.Contact
                                        Details</strong></small></li>
                            <li class="pl-2"><small class="common-bene-class-for-translation">Current Address</small>
                            </li>
                            <li class="pl-2"><small class="common-bene-class-for-translation">Phone Number</small></li>
                            <li class="pl-2"><small class="common-bene-class-for-translation">Email
                                    Address(Personal)</small></li>
                        </ul>
                    </div>
                </div>
                <div class="row pb-2" [ngClass]="{'highlightTextg1':!searchLimited}" *ngIf="!searchLimited">
                    <div class="col-md-12">
                        <small class="common-bene-class-for-translation">
                            Your entire profile data will be visible to all the members and petioners whne they search
                            for you
                        </small>
                    </div>
                </div>
                <!---desc--->
            </ng-container>
            <div class="row mt-2 dotted-top-border">
                <button (click)="setSearchVisibility()" class="pl-4 pr-4 mt-4 mat-stroked-button" type="button"><span
                        class="common-bene-class-for-translation">Update</span></button>
            </div>
        </div>
        <!---collapseBox1 end-->
    </div>
    <!---user-name-card card-body---->
</div>
<!--MAIN content-->


<div class="main-content" *ngIf="userTypeRole === 'Beneficiary'">
    <div class="card user-name-card card-body">

        <div class="flex-row bold-bottom-border pb-20">
            <div>
                <div>
                    <h6 class="common-bene-class-for-translation"> Profile edit permission to Petitioners and Lawfirms
                    </h6>
                </div>
                <div class="un-sub-ttle common-bene-class-for-translation">
                    Give your petitioner rights to edit your profile
                </div>
            </div>

            <div class="align-right">
                <a class="primary" data-toggle="collapse" #profileEditBlock href="#collapseBox2" role="button"
                    aria-expanded="false">
                    <span class="common-bene-class-for-translation"
                        [ngClass]="{'noDipsplay': !profileEdit_block_change}">Change</span>
                    <span class="common-bene-class-for-translation"
                        [ngClass]="{'noDipsplay':  profileEdit_block_change}">Close</span>
                </a>
            </div>
        </div>


        <div class="collapse ml-14ve" id="collapseBox2">
            <div class="row"></div>
            <div class="row" *ngFor="let company of this.companyPermitEditList;let i = index;">
                <div class="col-md-12">
                    <p><strong>{{company.companyName}}</strong><span class="common-bene-class-for-translation"> has the
                            rights to view your profile data.</span></p>
                    <mat-label class="common-bene-class-for-translation">Do you want to allow them to Update
                        (Add/Edit/Delete) your profile information?
                    </mat-label>
                    <mat-radio-group [(ngModel)]="CompanyPermitEditCheckBox[i] = company.isEditable"
                        [value]="company.isEditable">
                        <mat-radio-button class="radio-button"
                            (change)="setProfileEditConfig(company.companyId,CompanyPermitEditCheckBox[i],1)"
                            name="{{'searchLimited'+i}}" [value]="1">
                            <span class="common-bene-class-for-translation">Yes</span>
                        </mat-radio-button>
                        <mat-radio-button class="radio-button" name="{{'searchLimited'+i}}"
                            (change)="setProfileEditConfig( company.companyId,CompanyPermitEditCheckBox[i],0)"
                            [value]="0">
                            <span class="common-bene-class-for-translation">No</span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div *ngIf="this.companyPermitEditList.length<1" class="row mt-2 border-top">
                <div class="col-md-12">
                    <p class="text-center nodata"><strong class="common-bene-class-for-translation">No Data</strong>
                    <p>
                </div>
            </div>
            <div class="row mt-2 border-top">
                <div class="col-md-12 ">
                    <button (click)="saveProfileEditPermission()" class="pl-4 pr-4 mat-stroked-button mt-4 "
                        type="button"><span class="common-bene-class-for-translation">Update</span></button>
                </div>
            </div>

        </div>
        <!---collapseBox2 end-->
    </div>
    <!---user-name-card card-body---->
</div>
<!--MAIN content-->


<form (ngSubmit)="postNotifyList()" #notifyListForm="ngForm" class="pb-3 notifyContent">
    <div class="main-content">
        <div class="notifyNote">
            <h6><b class="common-bene-class-for-translation">Note : </b> <span
                    class="common-bene-class-for-translation">If non-editable, access denied by admin </span> </h6>
        </div>
        <div class="row margin-adjust">
            <div class="col-6">
                <div class="card user-name-card card-body mb-4">
                    <div class="flex-row bold-bottom-border">
                        <div class="col-md-10">
                            <h6 class="common-bene-class-for-translation"> Email Notification</h6>
                            <div class="un-sub-ttle common-bene-class-for-translation">
                                Enable/disable email notifications
                            </div>
                        </div>
                        <div class="col-md-2 d-flex justify-content-end notify-switches">
                            <p-inputSwitch [disabled]="isEmailOn" name="isEmailSettingEnabled" class="notifyDisabled"
                                [(ngModel)]="notifySettings.emailSettingsDto.isEmailSettingEnabled"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card user-name-card card-body mb-4">
                    <div class="flex-row bold-bottom-border">
                        <div class="col-md-10">
                            <h6 class="common-bene-class-for-translation"> In-App Notifications </h6>
                            <div class="un-sub-ttle common-bene-class-for-translation">
                                Enable/disable App notifications
                            </div>
                        </div>
                        <div class="col-md-2 d-flex justify-content-end notify-switches">
                            <p-inputSwitch [disabled]="isInAppOn" name="isInAppSettingEnabled" class="notifyDisabled"
                                [(ngModel)]="notifySettings.inAppSettingsDto.isInAppSettingEnabled"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2 pl-0">
                <button type="submit" label="Save" class="save-btn" icon="pi pi-save"
                    [ngClass]="'btn-success button-width-icon-left mr-3'">
                    <span class="common-bene-class-for-translation">Save</span>
                </button>
            </div>
        </div>
    </div>
</form>